export const setDragImage = ((e) => {
  let dragImage = document.getElementById('dragImage')

  if(dragImage == null){

    dragImage = document.createElement('img')
    dragImage.id = "dragImage"
    dragImage.style.cssText = "display: none;"
    dragImage.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg=="

    document.body.appendChild(dragImage);
  }

  var testVar = window.DataTransfer || window.Clipboard;  // Clipboard is for Chrome
  if("setDragImage" in testVar.prototype) {
      e.dataTransfer.setDragImage(dragImage, 0, 0)
  }
  if("setData" in testVar.prototype){
      e.dataTransfer.setData('text/plain', '');
  }
})

export const getTransform = ((elem) => {
  var matrix = getComputedStyle(elem, null).transform;

  var regex = /-?\d*\.{0,1}\d+/g;
  var values = matrix.match(regex);

  var translateX = '';
  var translateY = '';

  if (values != null) {
    translateX = values[4];
    translateY = values[5];
  }

  return {
    'translateX': translateX,
    'translateY': translateY
  };
});

export const start = ((objEvent, target, sceneScale, userScale) => {

  target.lastX = (objEvent.clientX / (sceneScale * userScale));
  target.lastY = (objEvent.clientY / (sceneScale * userScale));

  let offset = calculatePosition(target.parentNode);
  target.xPos = offset.left + document.getElementsByClassName("protocol-view")[0].scrollLeft;
  target.yPos = offset.top + document.getElementsByClassName("protocol-view")[0].scrollTop;

  target.lastRotation = 0;
  target.isAnimated = false;
  target.setAttribute( 'style', 'z-index: 99 !important; transform:' + target.style.transform +';' );
  target.setAttribute('aria-grabbed', 'true');

  return false;
});

export const limitNumberWithinRange = (num, min, max) => {
  const MIN = min || 1;
  const MAX = max || 20;
  const parsed = parseInt(num)
  return Math.min(Math.max(parsed, MIN), MAX)
}

export const drag = ((objEvent, objCurrent, userScale, sceneScale) => {
  if (objCurrent != null) {

    // Calculate new position
    var iCurrentY = (objEvent.clientY / (sceneScale * userScale));
    var iCurrentX = (objEvent.clientX / (sceneScale * userScale));

    var transform = getTransform(objCurrent);

    var iYPos = parseFloat(transform.translateY);
    var iXPos = parseFloat(transform.translateX);

    var iNewX = iXPos + iCurrentX - objCurrent.lastX;
    var iNewY = iYPos + iCurrentY - objCurrent.lastY;

    // Check transform constraints
    // if(iNewX < -objCurrent.xPos){ //Left Edge
    //   iNewX = -objCurrent.xPos
    // }
    // if(iNewX > 1515 - objCurrent.xPos - objCurrent.offsetWidth){ //Right Edge
    //   iNewX = 1515 - objCurrent.xPos - objCurrent.offsetWidth
    // }
    // if(iNewY < -objCurrent.yPos){ //Top Edge
    //   iNewY = -objCurrent.yPos
    // }
    // if(iNewY > (900 - objCurrent.yPos - objCurrent.offsetHeight)){ //Bottom Edge
    //   iNewY = 900 - objCurrent.yPos - objCurrent.offsetHeight
    // }

    var delta = (iCurrentX - objCurrent.lastX) * 3;
    var rotation = limitNumberWithinRange(parseInt(delta * 100 / 360, 10), -60, 60);
    var rotate = 0;

    if(delta !== 0){
      rotate = rotation;
    } else {
      rotate = objCurrent.lastRotation;
    }

    objCurrent.style.transform = 'translate3d(' + iNewX + 'px, ' + iNewY + 'px, 0px) rotateZ(' + rotate + 'deg) ';

    objCurrent.lastX = iCurrentX;
    objCurrent.lastY = iCurrentY;
    objCurrent.lastRotation = rotation;
    objCurrent.isAnimated = false;
  }
  return false;
});

export const end = ((e, objCurrent, objPrevious) => {
  // Set the current active element to null
  if (objCurrent != null) {
    objCurrent.style.zIndex = '2';
    objCurrent.setAttribute('aria-grabbed', 'false');
    if (objPrevious !== null && objPrevious !== objCurrent) {
      objPrevious.style.zIndex = "";
    }
  }

  return false;
});

export const calculatePosition = ((objElement) => {

	//var offset = { left: 0, top: 0 };
	const objPos = objElement.getBoundingClientRect();

	return objPos;
});

export const getTarget = ((current, targetList, userScale, sceneScale) => {

	let iCurrentXCenter, iCurrentYCenter;

	if (current != null) {
		//var strExisting = current.parentNode.getAttribute('id');
		var offset =  calculatePosition(current);

		if(current.id === 'P2_1' || current.id === 'P20_2' || current.id === 'P200_3'|| current.id === 'P1000_4' ) {
			iCurrentXCenter = (offset.left /  (sceneScale * userScale)) + (current.parentNode.offsetWidth / 2);
			iCurrentYCenter = ((offset.top /  (sceneScale * userScale)) + (current.parentNode.offsetHeight / 2) + (100));
		} else if (current.parentNode.parentNode.classList.contains('IceBucketTubes')) {
			iCurrentXCenter = (offset.left /  (sceneScale * userScale)) + (current.offsetWidth / 2);
			iCurrentYCenter = (offset.top /  (sceneScale * userScale)) + (current.offsetHeight / 2);
		} else {
			iCurrentXCenter = (offset.left /  (sceneScale * userScale)) + (current.parentNode.offsetWidth / 2);
			iCurrentYCenter = (offset.top /  (sceneScale * userScale)) + (current.parentNode.offsetHeight / 2);
		}

		//var iTolerance = 70;
		var iLeft, iRight, iTop, iBottom, iCounter;

		// console.log(current.id, iCurrentXCenter, iCurrentYCenter);

		//var tNode = document.createElement('div');
		//document.getElementById('dragdrop').appendChild(tNode);

		// tNode.className = current.id;
		// tNode.style.position = 'absolute';
		// tNode.style.left = iCurrentXCenter+'px';
		// tNode.style.top = iCurrentYCenter+'px';
		// tNode.style.width = 2+'px';
		// tNode.style.height = 2+'px';
		// tNode.style.border = '3px solid green';

		for (iCounter = 0; iCounter < targetList.length; iCounter++) {

			if(current.id !== targetList[iCounter].id) {
				offset = calculatePosition(targetList[iCounter]);

				iLeft = (offset.left) /  (sceneScale * userScale);
				iRight = (iLeft + targetList[iCounter].offsetWidth);
				iTop = (offset.top) /  (sceneScale * userScale);
				iBottom = (iTop + targetList[iCounter].offsetHeight);

				// var node = document.createElement('div');
				// document.getElementById('dragdrop').appendChild(node);
        //
				// node.className = targetList[iCounter].id;
				// node.style.position = 'absolute';
				// node.style.left = iLeft+'px';
				// node.style.top = iTop+'px';
				// node.style.width = (iRight - iLeft)+'px';
				// node.style.height = (iBottom - iTop)+'px';
				// node.style.border = '3px solid red';
				//
				// console.log("Pipette: x: ", iCurrentXCenter," y: ",iCurrentYCenter);
				// console.log("target: ",iLeft," ",iRight," ",iBottom," ",iTop);

				// Determine if current object is over the target
				if (iCurrentXCenter > iLeft && iCurrentXCenter < iRight && iCurrentYCenter > iTop && iCurrentYCenter < iBottom) {
					//node.style.border = '3px solid green';
					return targetList[iCounter];
				}
			}
		}
	}
	// Current object is not over a target
	return '';
});
